module.exports = __webpack_public_path__ + "img/check.e35ebd92.svg";